var CustomTagField = function (config) {
  jsGrid.Field.call(this, config);
};

CustomTagField.prototype = new jsGrid.Field({
  itemTemplate: function (value, item) {
    var tagCss = this._grid.tagCss
    var $link = $("<strong>")
      .addClass(getCss(value))
      .text(value.charAt(0).toUpperCase() + value.slice(1));
    return $link;

    function getCss (value) {
      if (tagCss) {
        return tagCss[value.trim().toLowerCase()]
      }
      return ''
    }
  }
});

module.exports = CustomTagField;